import { render, staticRenderFns } from "./CustomerHomepageItemNotInBarrel.vue?vue&type=template&id=ace179b6&"
import script from "./CustomerHomepageItemNotInBarrel.vue?vue&type=script&lang=ts&"
export * from "./CustomerHomepageItemNotInBarrel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports